import { AddressQuestion } from "./questionTypes";

interface AddressQuestionProps {
  question: AddressQuestion;
  values: Record<string, string>;
  onChange: (questionId: string, values: Record<string, string>) => void;
}

export function AddressQuestionComponent({
  question,
  values,
  onChange
}: AddressQuestionProps) {
  const handleFieldChange = (fieldId: string, value: string) => {
    const newValues = { ...values, [fieldId]: value };
    onChange(question.id, newValues);
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">{question.title}</h2>
        {question.description && (
          <p className="text-muted-foreground mb-6">{question.description}</p>
        )}
      </div>
      
      <div className="space-y-4">
        {question.fields.addressLine1 && (
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">
              Address Line 1 <span className="text-destructive ml-1">*</span>
            </label>
            <input
              type="text"
              value={values.addressLine1 || ''}
              onChange={(e) => handleFieldChange('addressLine1', e.target.value)}
              placeholder="Street address"
              className="w-full p-3 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              required
            />
          </div>
        )}

        {question.fields.addressLine2 && (
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">
              Address Line 2
            </label>
            <input
              type="text"
              value={values.addressLine2 || ''}
              onChange={(e) => handleFieldChange('addressLine2', e.target.value)}
              placeholder="Apartment, suite, etc. (optional)"
              className="w-full p-3 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {question.fields.city && (
            <div className="space-y-2">
              <label className="text-sm font-medium text-foreground">
                City <span className="text-destructive ml-1">*</span>
              </label>
              <input
                type="text"
                value={values.city || ''}
                onChange={(e) => handleFieldChange('city', e.target.value)}
                placeholder="City"
                className="w-full p-3 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                required
              />
            </div>
          )}

          {question.fields.stateProvince && (
            <div className="space-y-2">
              <label className="text-sm font-medium text-foreground">
                State/Province <span className="text-destructive ml-1">*</span>
              </label>
              <input
                type="text"
                value={values.stateProvince || ''}
                onChange={(e) => handleFieldChange('stateProvince', e.target.value)}
                placeholder="State or Province"
                className="w-full p-3 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                required
              />
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {question.fields.country && (
            <div className="space-y-2">
              <label className="text-sm font-medium text-foreground">
                Country <span className="text-destructive ml-1">*</span>
              </label>
              <input
                type="text"
                value={values.country || ''}
                onChange={(e) => handleFieldChange('country', e.target.value)}
                placeholder="Country"
                className="w-full p-3 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                required
              />
            </div>
          )}

          {question.fields.postalCode && (
            <div className="space-y-2">
              <label className="text-sm font-medium text-foreground">
                Postal Code
              </label>
              <input
                type="text"
                value={values.postalCode || ''}
                onChange={(e) => handleFieldChange('postalCode', e.target.value)}
                placeholder="Postal/ZIP code"
                className="w-full p-3 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}